import React, { Fragment, PureComponent } from "react";
import withAppData from "../HOC/withAppData";
import "react-alice-carousel/lib/alice-carousel.css";
import {
	_cloneObject,
	_isSameDay,
	_cloneArray,
	_formatCurrency,
} from "../Utils/helpers";
import dayjs from "dayjs";
import { GET } from "../Utils/api";
import TransactionHistory from "./TransactionHistory/TransactionHistory";
import "../Styles/Pages/homepage.scss";



class BusinessHome extends PureComponent {
	constructor(props) {
		super(props);
		this.analyticsDropdownRef = React.createRef();
		this.state = {
			workDay: {
				keyactivities: {},
				tasklist: [],
			},
			weekdays: [],
			days: [],
			currentDate: "",
			isTasksLoading: true,
			isActivityLoading: true,
			isStartDay: false,
			isStopDay: false,
			currentDay: [],
			dayCompleted: false,
			currentIndex: 0,
			hideGeolocationPrompt: true,
			showAnaltyicsDropdown: false,
			showCustomDateModal: false,
			toDate: dayjs().format("YYYY-MM-DD"),
			fromDate: dayjs().format("YYYY-MM-DD"),
			selectedTime: "Today",
			showLoader: true,
			flagPrm: 0,
			countDaysPrm: 0,
			preventLoader: false,
			showKeyActivities: false,
			businessDashboardReport: [],
			bannerError: false,
			showTransactionHistory: false,
			previousDateSummary: {},
			showPendingRequestsModal: false,
			hideBanner: localStorage.getItem("bannerError"),
			newWalletBalance: 0,
			isLoadingWallet: true,
		};
	}

	getNewWalletBalance = async () => {
		// console.log(this.props.context.jsonHeader.headers)
		// console.log(this.props.context.HeaderData)
		// console.log(this.props.context)
		console.log(this.props)
		const walletBalance = await GET(
			`OmniPay/GetDriverOmniPayWalletBalance?driverId=${this.props.userId}`,
		);
		if (!walletBalance.error) {
			this.setState({
				newWalletBalance: walletBalance.Data.AvailableBalance,
				isLoadingWallet: false,
			});
		}
	};

	componentDidMount() {
		debugger
		console.log("getting old transaction")
		this.getNewWalletBalance();
	}

	render() {

		return (
			<div className="dashboard-page">
				<div className="bo-dashboard-home">
					<div className="bo-dashboard-home-right">
						{this.state.showTransactionHistory
							? <TransactionHistory backAction={() => this.setState({showTransactionHistory: false})}/>
							: (<Fragment>
								<div className="bo-businesswrapper">
									<div className="bo-business-activity ">
										<div className="bo-business-activity-top">
											<div className="bo-business-activity-top-card">
												<p className="bo-business-activity-top-card-wallet">
													Wallet Balance
												</p>
												<p className="bo-business-activity-top-card-balance">
													{`${this.state.isLoadingWallet
														? "--"
														: _formatCurrency(
															this.state.newWalletBalance || 0,
														)
														}`}
												</p>
												<div className="bo-business-activity-top-card-history">
													<a
														onClick={() => this.setState({ showTransactionHistory: true })}
														className="bo-business-activity-top-card-history"
													>
														View Transaction History
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Fragment>
							)}
					</div>
				</div>
			</div>
		);
	}
}

export default withAppData(BusinessHome);
